var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4216 6.59286C12.4216 7.93739 11.9851 9.17939 11.2499 10.1871L14.9583 13.8984C15.3245 14.2646 15.3245 14.8592 14.9583 15.2254C14.5921 15.5915 13.9975 15.5915 13.6313 15.2254L9.9229 11.514C8.91523 12.2522 7.67323 12.6857 6.3287 12.6857C2.96298 12.6857 0.23584 9.95858 0.23584 6.59286C0.23584 3.22714 2.96298 0.5 6.3287 0.5C9.69442 0.5 12.4216 3.22714 12.4216 6.59286ZM6.3287 10.811C8.65746 10.811 10.5468 8.92162 10.5468 6.59286C10.5468 4.2641 8.65746 2.37473 6.3287 2.37473C3.99994 2.37473 2.11057 4.2641 2.11057 6.59286C2.11057 8.92162 3.99994 10.811 6.3287 10.811Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorOrange);
export default __webpack_public_path__ + "static/media/Vector-Orange.c6a7a2fbc26f1681f602287551db4588.svg";
export { ForwardRef as ReactComponent };